import React from "react";
import Layout from "../../components/Layout/Layout";
import { useState } from "react";
import { HollowDotsSpinner } from "react-epic-spinners";
import BackButton from "../../components/BackButton";
import { useNavigate } from "react-router-dom";
import ThirdPartyServices from "../../services/ThirdParty";
import fire from "../../utils/Toastr";
export default function ThirdParty() {
  const [applicationName, setApplicationName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyUniqueIdentifier, setCompanyUniqueIdentifier] = useState("");
  const [address, setAddress] = useState("");
  const [accountNo, setAccountNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [errMessage, setErrorMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  const nav = useNavigate();

  const thirdParty = {
    applicationName: applicationName,
    companyName: companyName,
    companyUniqueIdentifier: companyUniqueIdentifier,
    address: address,
    accountNumber: accountNo,
  };

  const validateForm = () => {
    let errors = {};

    if (!applicationName)
      errors.applicationName = "Application Name is required";
    if (!companyName) errors.companyName = "Company Name is required";
    if (!companyUniqueIdentifier)
      errors.companyUniqueIdentifier = "Company Unique Identifier is required";
    if (!address) errors.address = "Address is required";
    if (!accountNo) errors.accountNo = "Account Number is required";
    else if (!/^\d+$/.test(accountNo))
      errors.accountNo = "Account Number must be numeric";

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      const res = await ThirdPartyServices.ThirdPartyUsers(thirdParty);
      if (res.status) {
        fire("success", res.message);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        nav("/thirdparty");
        console.log("res", res);
      } else {
        setErrorMessage(res.message || "An error occurred");
      }
    } catch (error) {
      setErrorMessage(" ");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <Layout
        title="Add Third-Party Organization User"
        pageTag={"thirdparty"}
        current={"/create/thirdparty"}
      >
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto">
              <BackButton />
              <div className="px-4 sm:px-6 lg:px-8">
                <div className="mt-8 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                      <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                        <div className="">
                          <div className="block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                            {/* form */}
                            <form className="px-6" onSubmit={submitForm}>
                              <div className="mt-6 mb-12 grid grid-cols-1 sm:grid-cols-2 gap-4 p-4">
                                <div className="">
                                  <label
                                    htmlFor="applicationName"
                                    className="ml-1 block text-sm font-medium text-gray-700"
                                  >
                                    Application Name
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="applicationName"
                                      id="applicationName"
                                      placeholder="Enter Application Name"
                                      value={applicationName}
                                      onChange={(e) =>
                                        setApplicationName(e.target.value)
                                      }
                                      className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                    {validationErrors.applicationName && (
                                      <p className="mt-2 text-sm text-red-600">
                                        {validationErrors.applicationName}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="">
                                  <label
                                    htmlFor="companyName"
                                    className="ml-1 block text-sm font-medium text-gray-700"
                                  >
                                    Company Name
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="companyName"
                                      id="companyName"
                                      placeholder="Enter Company Name"
                                      value={companyName}
                                      onChange={(e) =>
                                        setCompanyName(e.target.value)
                                      }
                                      className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                    {validationErrors.companyName && (
                                      <p className="mt-2 text-sm text-red-600">
                                        {validationErrors.companyName}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="">
                                  <label
                                    htmlFor="companyUniqueIdentifier"
                                    className="ml-1 block text-sm font-medium text-gray-700"
                                  >
                                    Company Unique Identifier
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="companyUniqueIdentifier"
                                      id="companyUniqueIdentifier"
                                      placeholder="Enter Company Unique Identifier"
                                      value={companyUniqueIdentifier}
                                      onChange={(e) =>
                                        setCompanyUniqueIdentifier(
                                          e.target.value
                                        )
                                      }
                                      className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                    {validationErrors.companyUniqueIdentifier && (
                                      <p className="mt-2 text-sm text-red-600">
                                        {
                                          validationErrors.companyUniqueIdentifier
                                        }
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="">
                                  <label
                                    htmlFor="accountNumber"
                                    className="ml-1 block text-sm font-medium text-gray-700"
                                  >
                                    Account Number
                                  </label>
                                  <div className="mt-1">
                                    <input
                                      type="text"
                                      name="accountNumber"
                                      id="accountNumber"
                                      placeholder="Enter Account Number"
                                      value={accountNo}
                                      onChange={(e) =>
                                        setAccountNo(e.target.value)
                                      }
                                      className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                    {validationErrors.accountNo && (
                                      <p className="mt-2 text-sm text-red-600">
                                        {validationErrors.accountNo}
                                      </p>
                                    )}
                                  </div>
                                </div>
                                <div className="">
                                  <label
                                    htmlFor="address"
                                    className="ml-1 block text-sm font-medium text-gray-700"
                                  >
                                    Address
                                  </label>
                                  <div className="mt-1 w-[100%]">
                                    <textarea
                                      rows="5"
                                      cols="50"
                                      name="address"
                                      id="address"
                                      placeholder="Enter Your Company Address"
                                      value={address}
                                      onChange={(e) =>
                                        setAddress(e.target.value)
                                      }
                                      className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                    />
                                    {validationErrors.address && (
                                      <p className="mt-2 text-sm text-red-600">
                                        {validationErrors.address}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="flex items-center justify-center w-full mb-4">
                                <button
                                  type="submit"
                                  className="btn-primary inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                >
                                  Create Organization
                                </button>
                              </div>
                            </form>
                            {loading && (
                              <div className="flex justify-center mt-4">
                                <HollowDotsSpinner color="#4A90E2" />
                              </div>
                            )}
                            {errMessage && (
                              <div className="flex justify-center mt-4 text-red-500">
                                {errMessage}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div></div>
          </main>
        </React.Fragment>
      </Layout>
    </>
  );
}
